export { jsSelector as default };

const jsSelector = {

    view () {        
        var url = new URL(window.location.href);        
        return url.searchParams.get('view');    
    },

    type () {        
        var url = new URL(window.location.href);        
        return url.searchParams.get('type');    
    }
    
}
